import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  { path: "/", name: "home", component: () => import("./pages/Home.vue") },
  { path: "/login", name: "login", component: () => import("./pages/Login.vue") },
  { path: "/callback", name: "callback", component: () => import("./pages/Callback.vue") },
  { path: "/cli-login", name: "cli-login", component: () => import("./pages/CliLogin.vue") },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("./pages/Dashboard.vue"),
    meta: { requiresAuth: true },
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
